import React from "react";
import "../assets/styles/components/Temoignages.css";
import profileImage from "../assets/images/profile-image.jpg"; // Remplacez par une image réelle

const Temoignages = () => (
  <section id="temoignages" className="py-5">
    <div className="container text-center">
      <h2 className="mb-4">Témoignages</h2>
      <p className="text-muted mb-5">Découvrez ce que les gens disent</p>
      <blockquote className="blockquote">
        <p>
          &ldquo;J’ai loué un bureau chez ACG VO à Villiers-Le-Bel et je suis
          ravi de l’environnement de travail. Le cadre est calme et
          professionnel, idéal pour se concentrer sur mes projets. Le personnel
          est accueillant et toujours prêt à aider.&rdquo;
        </p>
        <footer className="blockquote-footer mt-3">
          <img
            src={profileImage}
            alt="Ervin Howell"
            className="testimonial-profile"
          />
          <span className="author">
            Ervin Howell, Produit du vice-président, Deckow-Crist
          </span>
        </footer>
      </blockquote>
    </div>
  </section>
);

export default Temoignages;
